import {GROUP_TYPE, CURSOR, getTextColor, GROUP_SECTION_WIDTH, getTrimmedText, drawBorderLines /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import {profilePicSrc} from '../../../../constants';
import Util from '../../../../forecast-app/shared/util/util';
import {drawExpansionImageIcon} from '../../canvas-timeline/canvas_timeline_icon_util';

class PersonGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON, data);
		data.personId = data.id;
	}

	get groupIds() {
		if (this.data.isHeatMapDisabled()) {
			return this.data.groupIds;
		}
		return undefined;
	}

	get renderRowLines() {
		return true;
	}

	set renderRowLines(renderRowLines) {}

	get preventExpansion() {
		return this.data.isHeatMapDisabled() ? false : this._preventExpansion;
	}

	set preventExpansion(preventExpansion) {
		this._preventExpansion = preventExpansion;
	}

	get expanded() {
		return this.data.isHeatMapDisabled() ? false : this._expanded;
	}

	set expanded(expanded) {
		this._expanded = expanded;
	}

	get itemRowHeight() {
		if (this.data.isHeatMapDisabled()) {
			return 39;
		} else {
			return this._itemRowHeight;
		}
	}

	set itemRowHeight(itemRowHeight) {
		this._itemRowHeight = itemRowHeight;
	}

	get height() {
		if (this.data.isHeatMapDisabled()) {
			// The height of the rows are 4 pixels larger than the item itself (2 on top/bottom)
			// This gives 4 pixels between all item rows (overlapping items), but only two pixel at the top/bottom of the group
			// Add 2 pixels more at the top (items adjusted in adjustItemY) and 13 pixels for the bottom padding.
			return this.itemRowCount * this.itemRowHeight + 2 + 13;
		}
		return this._height;
	}

	set height(height) {
		this._height = height;
	}

	adjustItemY(item, y) {
		let adjustedY = Math.floor(y + (this.itemRowHeight - 1 - item.height) / 2);
		if (this.data.isHeatMapDisabled()) {
			// Add 2 extra pixels at the top.
			adjustedY += 2;
		}
		return adjustedY;
	}

	addGroup(group) {
		// create the groupIds array if it does not exist to make sure we show the first created allocation of a newly added user
		if (!this.data.groupIds) this.data.groupIds = [];
		if (this.data.groupIds.indexOf(group.id) === -1) {
			const newGroupIndex = this.groups.length - 2; //Insert before non project time group and placeholder group
			this.groups.splice(newGroupIndex, 0, group);
			this.data.groupIds.push(group.id);
			this.data.groupIds.push(`${group.id}-task`);
		}
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, groupType, expanded} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		const {id, roleName, profilePictureId, name, onPersonImageLoad} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;

		if (!this.data.isHeatMapDisabled()) {
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);
		}

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		const textColor = getTextColor();

		const drawGroup = personImage => {
			drawBorderLines(canvasContext, x, y, width, height, true);

			const left = x + this.marginX;
			if (!this.data.isHeatMapDisabled()) {
				drawExpansionImageIcon(canvasContext, left, y, width - this.marginX, height, {
					expanded,
					align: 'left',
				});
			}

			//Person name
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			canvasContext.fillStyle = textColor;
			canvasContext.fillText(getTrimmedText(canvasContext, name), left + 78, y + (roleName ? 20 : 28));
			//Person role
			if (roleName) {
				canvasContext.fillStyle = '#a1a1a1';
				canvasContext.font = 'normal 12px ' + Util.getFontFamily();
				canvasContext.fillText(getTrimmedText(canvasContext, roleName), left + 78, y + 36);
			}
			if (personImage) {
				canvasContext.drawImage(personImage, left + 16 + 22, y + 8, 30, 30);
			} else {
				//draw hexagon with initials
				canvasContext.beginPath();
				const xOrigin = left + 32 + 22,
					yOrigin = y + 8;
				canvasContext.moveTo(xOrigin, yOrigin);
				canvasContext.lineTo(xOrigin, yOrigin);
				canvasContext.lineTo(xOrigin + 13, yOrigin + 7, 575);
				canvasContext.lineTo(xOrigin + 13, yOrigin + 22, 425);
				canvasContext.lineTo(xOrigin, yOrigin + 30);
				canvasContext.lineTo(xOrigin, yOrigin + 30);
				canvasContext.lineTo(xOrigin - 13, yOrigin + 22, 425);
				canvasContext.lineTo(xOrigin - 13, yOrigin + 7, 575);
				canvasContext.fillStyle = '#6e0fea';
				canvasContext.fill();
				if (name) {
					canvasContext.font = '700 10px ' + Util.getFontFamily();
					canvasContext.fillStyle = 'white';
					const initials = Util.getInitials(name);
					canvasContext.textAlign = 'center';
					canvasContext.fillText(getTrimmedText(canvasContext, initials.toUpperCase()), xOrigin, yOrigin + 18);
				}
				canvasContext.textAlign = 'start';
			}
		};

		const cachedImage = cacheManager.get('personImage', id);

		if (cachedImage && profilePictureId) {
			drawGroup(cachedImage);
		} else {
			if (profilePictureId) {
				const personImage = new Image();
				personImage.crossOrigin = 'Anonymous';
				personImage.onload = () => {
					cacheManager.set('personImage', id, personImage);
					onPersonImageLoad();
				};
				personImage.src = profilePicSrc(profilePictureId);
			}
			drawGroup(null);
		}
	}
}

export default PersonGroup;
